import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PatientService } from '@services/patient.service';
import { ClinicReportDetailsViewModel } from '@services/reports.service';

@Component({
  selector: 'app-clinic-tax-details',
  templateUrl: './clinic-tax-details.component.html',
  styleUrls: ['./clinic-tax-details.component.less'],
})
export class ClinicTaxDetailsComponent {
  loading: boolean = false;
  @Input() taxDetails: ClinicReportDetailsViewModel[] = [];

  constructor(private router: Router, private patientService: PatientService) {}

  navigateToPatientInvoice(patientId: number, invoiceId: number) {
    this.patientService.getPatientById(patientId).subscribe((patient: any) => {
      this.patientService.patientPanelPatient = patient;
      this.router.navigate([
        '/reports',
        {
          outlets: {
            'action-panel': [
              'patient',
              patientId + '_patientprofiletab',
              'patienttabs',
              'patientaccounttab',
              'invoice',
              invoiceId,
            ],
          },
        },
      ]);
    });
  }
}
